import { Grid, Tooltip, Paper, Typography } from '@mui/material'
import { alpha, SxProps, Theme } from '@mui/material/styles'

export type DataCardProps = {
  title: string
  value: string
  description?: string
  faq?: string
  icon?: string
  sx?: SxProps<Theme>,
  borderColor?: string
};

export default function DataCard({
  title,
  value,
  description,
  faq,
  icon,
  sx,
  borderColor
}: DataCardProps) {
  return (
    <Paper
      elevation={3}
      sx={[
        {
          borderRadius: 3,
          p: 2,
          display: 'flex',
          flexDirection: 'column',
          justifyContent: 'space-between',
          mb: 2
        },
        sx,
      ] as SxProps<Theme>}
    >
      <Grid container
        sx={{ display: 'flex', flexDirection: 'row' }}
      >
        <Grid
          sx={{
            display: icon ? 'inline-flex' : 'none',
            alignSelf: 'center',
            alignItems: 'center',
            justifyContent: 'center',
            borderRadius: 3,
            p: 3,
            mr: 2,
            width: 40,
            height: 40,
            background: borderColor && alpha(borderColor, 0.1),
          }}
        >
          <calcite-icon icon={icon} style={{ color: borderColor, }} scale="m" />
        </Grid>
        <Grid
          size={icon ? 8 : 12}
        >
          <Grid
            container
            sx={{
              justifyContent: 'space-between',
              alignItems: 'center', // Align items vertically in the row
              width: '100%',
            }}
          >
            <Grid size={9}>
              <Typography variant="subtitle2" sx={{ fontSize: 10 }}>
                {title}
              </Typography>
            </Grid>
            {faq &&
              <Grid>
                <Tooltip title={faq} placement='right-start'>
                  <calcite-action icon="information" />
                </Tooltip>
              </Grid>
            }
          </Grid>

          <Typography variant="h6" sx={{ fontWeight: 700 }}>
            {value}
          </Typography>
          {description &&
            <Typography variant="caption" color="text.secondary">
              {description}
            </Typography>
          }
        </Grid>
      </Grid>
    </Paper>
  )
}